import React, { useCallback, useEffect, useMemo } from 'react';
import { Box, Button, Divider, IconButton, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { useMessage } from '../../../../components/Header';
import { IoMdArrowBack } from 'react-icons/io';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // minWidth: { sm: 500, xs: 300 },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
    width: "100%",
    height: "100%"
};

const LeaveModel = ({ handleClose, fetchLeaveType, leaveTypeId, openDelete, setSelectLeaveType,selectLeaveType }) => {
    const [values, setValues] = React.useState({
        name: '',
        noOfLeaves: ''
    });

    console.log(selectLeaveType,"sadsdsadasdasadasdas");

    let currentOrg = JSON.parse(localStorage.getItem("org"));
    const updateLeaveType = useCallback(async () => {
        if (!leaveTypeId) return;
        try {
            const response = await axios.get(`/hr/attendance/leaves-typesorgId=${currentOrg?._id}`);
            const data = response.data.leaveTypes;
            const leave = data.find(item => item._id === leaveTypeId);
            // setSelectLeaveType(leave);
            if (leave) {
                setValues({ name: leave.name, noOfLeaves: leave.noOfLeaves });
            }
        } catch (e) {
            console.log(e);
        }
    }, [leaveTypeId]);

    useEffect(() => {
        updateLeaveType();
    }, [updateLeaveType]);

    const title = leaveTypeId ? 'Edit Leave Type' : 'Add Leave Type';
    const buttonText = leaveTypeId ? 'Update' : 'Add';
    const method = leaveTypeId ? 'PATCH' : 'POST';
    const action = leaveTypeId
        ? `/hr/attendance/leaves-types/${leaveTypeId}`
        : `/hr/attendance/leaves-type?orgId=${currentOrg?._id}`;
    const successMessage = leaveTypeId
        ? 'Leave Type updated successfully'
        : 'Leave Type added successfully';

    const { showError, showSuccess } = useMessage();

    const customHandleChange = (event) => {
        const { name, value } = event.target;
        // Custom validation or transformation logic can go here
        setValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const submit = async (event) => {
        event.preventDefault();
        try {
            const response = await axios({
                method,
                url: action,
                data: values,
            });
            if (response.data.success) {
                showSuccess(successMessage);
                fetchLeaveType();
                handleClose();
            } else {
                showError(response.data.message);
            }
        } catch (e) {
            console.log(e);
            showError('An error occurred');
        }
    };

    return (
        <Box component="form" onSubmit={submit} sx={style}>
            <Box className='flex items-center gap-3'>
                <IconButton onClick={handleClose}>
                    <IoMdArrowBack sx={{ fontSize: { md: '22px', xs: "16px" } }} />
                </IconButton>
                <Typography id='modal-modal-title' variant='h5' component='h2'>
                    {title}
                </Typography>
            </Box>
            {/* <Divider sx={{ my: 2 }} /> */}
            <Typography id='modal-modal-description' sx={{ mt: 2, mb: 1 }}>
                Leaves Title
            </Typography>
            <TextField
                name='name'
                placeholder='Enter Title'
                type='text'
                fullWidth
                required
                value={values.name}
                onChange={customHandleChange}
                size='small'
            />
            <Typography id='modal-modal-description' sx={{ mt: 2, mb: 1 }}>
                Number of Days
            </Typography>
            <TextField
                type='number'
                name='noOfLeaves'
                placeholder='0'
                fullWidth
                required
                value={values.noOfLeaves}
                onChange={customHandleChange}
                size='small'
            />
            <Box mt={5} textAlign='right' sx={{ position: "absolute", bottom: 0, right: { md: 3, xs: 1 }, p: { md: 2, xs: 1 } }}>
                <Button onClick={() => {
                    if (leaveTypeId) {
                        setSelectLeaveType(leaveTypeId);
                        openDelete();
                        handleClose();
                    } else {
                        handleClose()
                    }
                }}
                    variant='outlined'
                    color={leaveTypeId ? 'error' : 'primary'}
                    sx={{ mx: 2, paddingX: { md: 3, xs: 0 } }}
                >
                    {leaveTypeId ? "Delete" : "Close"}
                </Button>
                <Button sx={{ paddingX: { md: 4, xs: 0 }, bgcolor: "#0080ff" }} variant='contained' type='submit'>
                    {buttonText}
                </Button>
            </Box>
        </Box>
    );
};

export default LeaveModel;
